import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
var _Pixel;
import "core-js/modules/esnext.iterator.map.js";
import User from "../../../../views/dashboard/models/User";
import JsonMappedModel from "../helpers/JsonMappedModel";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Pixel extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Pixel.id_attribute_name]: null,
      [Pixel.user_attribute_name]: User,
      [Pixel.type_attribute_name]: null,
      [Pixel.code_attribute_name]: null,
      [Pixel.token_attribute_name]: null,
      [Pixel.conversion_name_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getTypeAttributeName() {
    return Pixel.type_attribute_name;
  }
  static getCodeAttributeName() {
    return Pixel.code_attribute_name;
  }
  static getTokenAttributeName() {
    return Pixel.token_attribute_name;
  }
  static getConversionNameAttributeName() {
    return Pixel.conversion_name_attribute_name;
  }
  static getPixelTypes() {
    return [Pixel.FACEBOOK, Pixel.SNAPCHAT, Pixel.TWITTER, Pixel.TIKTOK, Pixel.GOOGLE, Pixel.POSTBACK, Pixel.MICROSOFT_CLARITY, Pixel.GOOGLE_TAG];
  }
  static getPixelConversionOptions(type) {
    switch (type) {
      case this.FACEBOOK:
        return this.FACEBOOK_CONVERSION_OPTIONS;
      case this.TIKTOK:
        return this.TIKTOK_CONVERSION_OPTIONS;
      default:
        return [];
    }
  }
  getType() {
    return this.getAttribute(Pixel.type_attribute_name);
  }
  getCode() {
    return this.getAttribute(Pixel.code_attribute_name);
  }
  getToken() {
    return this.getAttribute(Pixel.token_attribute_name);
  }
  getConversionName() {
    return this.getAttribute(Pixel.conversion_name_attribute_name);
  }
}
_Pixel = Pixel;
_defineProperty(Pixel, "FACEBOOK", 'facebook');
_defineProperty(Pixel, "SNAPCHAT", 'snapchat');
_defineProperty(Pixel, "TWITTER", 'twitter');
_defineProperty(Pixel, "TIKTOK", 'tiktok');
_defineProperty(Pixel, "GOOGLE", 'google');
_defineProperty(Pixel, "POSTBACK", 'postback');
_defineProperty(Pixel, "MICROSOFT_CLARITY", 'microsoft_clarity');
_defineProperty(Pixel, "GOOGLE_TAG", 'google_tag');
_defineProperty(Pixel, "CONVERSION_PURCHASE", 'Purchase');
_defineProperty(Pixel, "CONVERSION_LEAD", 'Lead');
_defineProperty(Pixel, "CONVERSION_COMPLETE_PAYMENT", 'CompletePayment');
_defineProperty(Pixel, "CONVERSION_PLACE_AN_ORDER", 'PlaceAnOrder');
_defineProperty(Pixel, "FACEBOOK_CONVERSION_OPTIONS", [_Pixel.CONVERSION_PURCHASE, _Pixel.CONVERSION_LEAD]);
_defineProperty(Pixel, "TIKTOK_CONVERSION_OPTIONS", [_Pixel.CONVERSION_COMPLETE_PAYMENT, _Pixel.CONVERSION_PLACE_AN_ORDER]);
_defineProperty(Pixel, "id_attribute_name", 'pixel_id');
_defineProperty(Pixel, "user_attribute_name", 'pixel_user');
_defineProperty(Pixel, "type_attribute_name", 'pixel_type');
_defineProperty(Pixel, "code_attribute_name", 'pixel_code');
_defineProperty(Pixel, "token_attribute_name", 'pixel_token');
_defineProperty(Pixel, "conversion_name_attribute_name", 'conversion_name');